<template>
  <div class="not-found">
    <img alt="Vue logo" src="../assets/logo.png">
    <br>
    404 - Page Not Found
  </div>
</template>

<script>

export default {
  name: 'PageNotFound'
}
</script>

<style scoped>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
#nav {
  padding: 30px;
}
#nav a {
  font-weight: bold;
  color: #2c3e50;
  /* &.router-link-exact-active {
    color: #42b983;
  } */
}
</style>
